"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectUtils = void 0;
function checkUserPermissionsOnProject(project, user, permissions) {
    return project.assignees
        .filter((assignee) => assignee.user._id === user._id)
        .reduce((accumulator, currentValue) => {
        return accumulator || permissions.includes(currentValue.group);
    }, false);
}
exports.ProjectUtils = {
    checkUserPermissionsOnProject,
};
